"use client";

import { c as _c } from "react/compiler-runtime";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import styles from "@/components/nft-image/NFTImage.module.scss";
import type { BaseRendererProps } from "@/components/nft-image/types/renderer-props";
import { getResolvedAnimationSrc } from "@/components/nft-image/utils/animation-source";
import { withArweaveFallback } from "@/components/nft-image/utils/gateway-fallback";
import { Col } from "react-bootstrap";
const globalScope = globalThis as typeof globalThis & {
  window?: Window | undefined;
};
export default function NFTVideoRenderer(props) {
  const $ = _c(43);
  let T0;
  let t0;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== props.bgStyle || $[1] !== props.height || $[2] !== props.heightStyle || $[3] !== props.id || $[4] !== props.imageStyle || $[5] !== props.nft || $[6] !== props.showBalance || $[7] !== props.showOriginal) {
    const animationSrc = getResolvedAnimationSrc(props.nft);
    const animationClassName = styles.nftAnimation ?? "";
    const compressedAnimationSrc = "metadata" in props.nft ? props.nft.compressed_animation : undefined;
    let t12;
    bb0: {
      if (compressedAnimationSrc == null || compressedAnimationSrc === "") {
        t12 = undefined;
        break bb0;
      }
      try {
        const baseUrl = globalScope.window.location.href;
        let t13;
        if ($[21] !== compressedAnimationSrc) {
          t13 = new URL(compressedAnimationSrc, baseUrl);
          $[21] = compressedAnimationSrc;
          $[22] = t13;
        } else {
          t13 = $[22];
        }
        t12 = t13.href;
      } catch {
        t12 = undefined;
      }
    }
    const normalizedCompressedAnimationSrc = t12;
    T0 = Col;
    t10 = `${animationClassName} ${props.heightStyle} ${props.bgStyle} d-flex justify-content-center align-items-center`;
    if ($[23] !== props.height || $[24] !== props.nft || $[25] !== props.showBalance) {
      t11 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
      $[23] = props.height;
      $[24] = props.nft;
      $[25] = props.showBalance;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    t0 = props.id ?? `video-${props.nft.id}`;
    t1 = true;
    t2 = true;
    t3 = true;
    t4 = true;
    t5 = true;
    t6 = "auto";
    t7 = !props.showOriginal && "metadata" in props.nft && props.nft.compressed_animation ? props.nft.compressed_animation : animationSrc;
    t8 = props.imageStyle;
    t9 = withArweaveFallback(t13 => {
      const {
        currentTarget
      } = t13;
      if ("metadata" in props.nft && currentTarget.src === normalizedCompressedAnimationSrc && animationSrc) {
        currentTarget.src = animationSrc;
      }
    });
    $[0] = props.bgStyle;
    $[1] = props.height;
    $[2] = props.heightStyle;
    $[3] = props.id;
    $[4] = props.imageStyle;
    $[5] = props.nft;
    $[6] = props.showBalance;
    $[7] = props.showOriginal;
    $[8] = T0;
    $[9] = t0;
    $[10] = t1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[8];
    t0 = $[9];
    t1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t12;
  if ($[27] !== t0 || $[28] !== t1 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t12 = <video id={t0} autoPlay={t1} muted={t2} controls={t3} loop={t4} playsInline={t5} preload={t6} src={t7} className={t8} onError={t9} />;
    $[27] = t0;
    $[28] = t1;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== T0 || $[39] !== t10 || $[40] !== t11 || $[41] !== t12) {
    t13 = <T0 className={t10}>{t11}{t12}</T0>;
    $[38] = T0;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  return t13;
}